/**
 * The Department's processes beyond a file's own procedure that the platform carries: a market study run under its market-study file and opened
 * from a signal, the ex-post evaluation's reminders, the sign-off of the annual statistics return, the advocacy method's approval and the sending
 * of an adopted opinion.
 */
export default {
  study: {
    stage: "Stage: {{stage}}",
    noFile: "Not yet run under a market-study file. Open its file – terms of reference, periods, consultation and the Director's or Under-Secretary's approval – or tie it to an existing one before its first data request, so that on a test file the requests reach no one.",
    noFileSent: "Not yet run under a market-study file. Open its file: the data requests already sent are filed under it.",
    noFileNotAuthorised: "Not yet run under a market-study file. An authorised officer opens it under the delegation-of-authority matrix.",
    openFile: "Open its market-study file",
    fileOpened: "Market-study file {{caseNumber}} opened.",
    requestedWithFile: "Study requested under market-study file {{caseNumber}} – the agent is drafting it now.",
    requestedWithoutFile: "The study is requested without its market-study file: an authorised officer opens the file from the study.",
    fileField: "Market-study file",
    fileFieldHint: "The study runs under its statutory file: the terms of reference, periods, consultation and the Ministry's approval are the file's stages.",
    fileModes: { Open: "Open a new market-study file", Link: "Tie to an existing market-study file" },
    existingFile: "Existing file",
    fileStudy: "Market study",
    fileNoStudy: "No Data Bank study is tied to this file yet",
  },
  exPost: {
    notAuthorised: "The Data Bank is read for the evaluation and its verdict recorded by an authorised officer under the delegation-of-authority matrix. Its officer is given the task {{period.expost.reminderBefore}} days before the due date, and the Director once it has passed.",
  },
  statistics: {
    hiddenFiles_one: "1 file you cannot open",
    hiddenFiles_other: "{{count}} files you cannot open",
    hiddenChecks_one: "A data check concerns 1 file you cannot open; the figures read it as the check says.",
    hiddenChecks_other: "Data checks concern {{count}} files you cannot open; the figures read them as the checks say.",
    signOffs: "Sign-off of the returns",
    signOffHint: "Once a year has ended, the authorised officer – the Director or above under the delegation-of-authority matrix – signs off its return. The sign-off records the figures and the data checks that had run; the year's figures are then locked, and the tables and the workbook show the signed figures, until the year is reopened with reasons.",
    signedYear: "{{year}} signed off by {{name}}, {{date}}",
    unsignedYear: "{{year}} not signed off",
    signOff: "Sign off",
    reopen: "Reopen",
    signTitle: "Sign off the {{year}} return",
    signHint: "The year's figures as they now stand, and the data checks that have run, are recorded with your sign-off; the figures are then locked.",
    reopenTitle: "Reopen the {{year}} return",
    reopenHint: "The signed figures stay in the audit trail. Once reopened, the year's figures may be corrected and are signed off again.",
    note: "Note (optional)",
    reasons: "Why the return is reopened",
    signed: "The {{year}} return is signed off; its figures are locked.",
    reopened: "The {{year}} return is reopened.",
    lockedYear: "Signed off on {{date}}: the figures are locked",
  },
  advocacy: {
    sendings: "Sent to the issuing authority",
    sendingsHint: "Each sending of the adopted opinion to the authority that issues the instrument, as an authorised officer recorded it: to whom, on which day and under which covering letter. The overview counts as sent only the opinions recorded here.",
    notSent: "No sending of this opinion is recorded yet.",
    recordedBy: "recorded by {{name}}",
    recordSending: "Record the sending",
    recordHint: "Record the opinion as sent once it has gone to the authority, with the day and the reference of the covering letter or message.",
    recipient: "Sent to",
    sentOn: "Sent on",
    reference: "Reference of the covering letter",
    referenceHint: "The Ministry's outgoing reference, or the message it went with.",
    note: "Note",
    record: "Record",
    sent: "Sending to {{recipient}} recorded.",
  },
  signals: {
    openStudy: "Open a market study",
    studyTitle: "Open a market study from this signal",
    studyHint: "A study of the signal's market is requested in the Market Study Studio and runs under its own market-study file, opened now with your reasons; the signal is named as its lead and taken under review.",
    studyReasons: "Why the market should be studied",
    studyReasonsHint: "Recorded on the file in your name (at least a sentence).",
    studyOpened: "Market study opened under {{caseNumber}}.",
    studyLink: "Market study {{caseNumber}}",
  },
};
